import { render, staticRenderFns } from "./OrderDetailSistecredito.vue?vue&type=template&id=4a199184"
import script from "./OrderDetailSistecredito.vue?vue&type=script&lang=js"
export * from "./OrderDetailSistecredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports